import {
  Suspense,
} from 'react';
import {
  RouterProvider,
} from 'react-router';
import {
  ThemeProvider,
} from 'styled-components';
import {
  useSelector,
} from 'react-redux';

import {
  getUiState,
} from 'web-selectors';

import {
  Spinner,
} from 'web-components';
import {
  Flex,
  GlobalStyle,
  configureTheme,
} from 'web-styled';
import router from 'web-router';

import Helmet from './Helmet';
import ErrorBoundary from './ErrorBoundary';
import * as S from './styled';

const mapState = state => ({
  ...getUiState([
    'namespace',
    'namespaceIsLoaded',
  ])(state),
});

const AppContainer = () => {
  const {
    namespace,
    namespaceIsLoaded,
  } = useSelector(mapState);

  if (!namespaceIsLoaded) return (<Spinner />);

  return (
    <ThemeProvider
      theme={configureTheme(namespace.symbol, namespace?.settings?.color_schema as any)}
    >
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
          <>
            <GlobalStyle />
            <RouterProvider router={router} />
          </>
        </ErrorBoundary>
        <S.ToastifyContainer />
        <Helmet
          title={namespace.page_title}
          favicon={namespace.favicon}
        />
      </Suspense>
    </ThemeProvider>
  );
};

export default AppContainer;
